import './App.css';
import './styles/styles.css'

function App() {
  return (
    <div className="App">
        {/* <nav className="navbar navbar-expand-lg navbar-light fixed-top" id="mainNav">
            <div className="container px-4 px-lg-5">
                <a className="navbar-brand" href="">Start Investing</a>
                <button className="navbar-toggler navbar-toggler-right" type="button" data-bs-toggle="collapse" data-bs-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
                    Menu
                    <i className="fas fa-bars"></i>
                </button>
                <div className="collapse navbar-collapse" id="navbarResponsive">
                    <ul className="navbar-nav ms-auto">
                        <li className="nav-item"><a className="nav-link" href="">About</a></li>
                        <li className="nav-item"><a className="nav-link" href="">Portfolio</a></li>
                        <li className="nav-item"><a className="nav-link" href="">Contact</a></li>
                    </ul>
                </div>
            </div>
        </nav> */}
        <header className="masthead">
            <div className="container px-4 px-lg-5 d-flex top-padding h-100 align-items-center justify-content-center">
                <div className="d-flex justify-content-center">
                    <div className="text-center">
                        <h1 className="mx-auto my-0 text-uppercase">Invest in dividend</h1>
                        <h2 className="mx-auto under-title">Our website is currently under construction. Thank you for your patience. </h2>
                        <h2 className="mx-auto bottom-0">info@investindividend.com</h2>
                    </div>
                </div>
            </div>
        </header>
                
        <script src="https://cdn.startbootstrap.com/sb-forms-latest.js"></script>
    </div>
  );
}

export default App;
